export { default } from "./hero"
